import type { StepConfigParams } from '@flows/configs/types'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'

const dental_already_covered = (params: StepConfigParams) => {
  return {
    stepContent: [
      {
        type: 'spacer',
        size: 'xlarge',
      },
      {
        type: 'spacer',
        size: 'xsmall',
      },
      {
        type: 'image',
        src: 'https://cdn.sanity.io/images/p4gom3ch/production/d5077ba2e6928d005b1d88c51585c69c81c13e96-600x600.png',
        width: 200,
        height: 200,
        align: 'center',
        useURI: true,
        contentFit: 'contain',
      },
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_dental:steps.dental_already_covered.health_insurance.title',
        },
        align: 'center',
        size: 'h3',
      },
      {
        type: 'text',
        emphasis: 'default',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_dental:steps.dental_already_covered.health_insurance.body',
        },
        align: 'center',
      },
    ],
    subFlow: params.subFlow,
    hideProgressBar: true,
    footer: {
      customButtons: [
        {
          buttonId: 'dental_covered_consultation',
          buttonType: 'default',
          buttonLabel: {
            type: 'translatableText',
            translationKey:
              'sharedFlows_dental:steps.dental_already_covered.health_insurance.consultation',
          },
          actionConfig: {
            type: 'dispatchedHook',
            callbackConfig: {
              name: 'dentalBookConsultation',
              inputs: [],
              outputs: [],
            },
          },
        },
        {
          buttonId: 'dental_already_covered_done',
          buttonType: 'outlined',
          buttonLabel: {
            type: 'translatableText',
            translationKey: 'sharedFlows_dental:steps.dental_already_covered.health_insurance.done',
          },
          actionConfig: {
            type: 'dispatchedHook',
            callbackConfig: {
              name: 'endDentalFlow',
              inputs: [],
              outputs: [],
            },
          },
        },
      ],
    },
    isFailureStep: true,
  } as const satisfies AnyStepConfiguration
}

export default dental_already_covered
